import { render, staticRenderFns } from "./InsectLocomotionIcon.vue?vue&type=template&id=0256e223&"
import script from "./InsectLocomotionIcon.vue?vue&type=script&lang=js&"
export * from "./InsectLocomotionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0256e223')) {
      api.createRecord('0256e223', component.options)
    } else {
      api.reload('0256e223', component.options)
    }
    module.hot.accept("./InsectLocomotionIcon.vue?vue&type=template&id=0256e223&", function () {
      api.rerender('0256e223', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/InsectLocomotionIcon.vue"
export default component.exports